'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './results.routes';
import 'angular-tree-control';
import 'angular-busy2';

import ResultCommonController from './result_common.controller';
import UserStatsController from './userstats.controller';

export default angular.module('everlaps.results', [uiRouter, 'treeControl', 'angular-busy'])
	.config(routing)
	.controller('ResultCommonController', ResultCommonController)
	.controller('UserStatsController', UserStatsController)
	.name;




// WEBPACK FOOTER //
// ./client/app/frontend/results/index.js